module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("To all our family and friends, living and dead,"), _c('br'), _vm._v("who shared their stories with us;"), _c('br'), _vm._v("to the readers who will pass them on;"), _c('br'), _vm._v("and in memory of our friends,"), _c('br'), _vm._v("Karen Harrigan and Drewry Meece Jr.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-319cc5e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780813173894_epub_ded_r1.vue
// module id = 66
// module chunks = 0